export var valuesWorkflowTranslationAPIs = ["Amplexor", "AzureAi"];
/*

*/ 
//# sourceMappingURL=WorkflowTranslationAPIs.js.map